import React from 'react';

export type ImageWithFallbackProps = {
  src: string;
  alt: string;
  className?: string;
};

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({ src, alt, className }) => {
  const [error, setError] = React.useState(false);
  if (error) {
    return (
      <div
        className={className}
        style={{ backgroundColor: '#333333', width: '100%', height: '100%' }}
      />
    );
  }
  return <img src={src} alt={alt} className={className} onError={() => setError(true)} />;
};

export default ImageWithFallback;
